<mat-sidenav-container autosize>
  <mat-sidenav
    #sidenav
    mode="side"
    [fixedInViewport]="true"
    [fixedTopGap]="40"
    [opened]="true"
  >
    <div class="nav main-nav" [ngClass]="{ open: (sideNav$ | async).expanded }">
      <!--Data Sources-->
      <div class="nav-group">
        @if ((sideNav$ | async).expanded) {
          <div class="nav-group-header">
            <div class="nav-group-title">Data Sources</div>
          </div>
        }
        <div
          class="nav-option"
          [routerLink]="SOURCES"
          [routerLinkActive]="['active-sidenav-route']"
        >
          <ng-icon name="HeroClipboardCheck"></ng-icon>
          @if ((sideNav$ | async).expanded) {
            <span>Surveys</span>
          }
        </div>
        <div
          class="nav-option"
          [routerLink]="CHATS"
          [routerLinkActive]="['active-sidenav-route']"
        >
          <ng-icon name="TablerMessages"></ng-icon>
          @if ((sideNav$ | async).expanded) {
            <span>Chat</span>
          }
        </div>
      </div>

      <!--Pipelines-->
      <div class="nav-group">
        @if ((sideNav$ | async).expanded) {
          <div class="nav-group-header">
            <div class="nav-group-title">Data Pipelines</div>
          </div>
        }
        <div
          class="nav-option"
          [routerLink]="PIPELINE_PROGRESS"
          [routerLinkActive]="['active-sidenav-route']"
        >
          <ng-icon name="TablerBatteryEco"></ng-icon>
          @if ((sideNav$ | async).expanded) {
            <span>CX Chat</span>
          }
        </div>
      </div>

      <!--Models-->
      <div class="nav-group">
        @if ((sideNav$ | async).expanded) {
          <div class="nav-group-header">
            <div class="nav-group-title">Models</div>
          </div>
        }
        <div
          class="nav-option"
          [routerLink]="CATEGORY"
          [routerLinkActive]="['active-sidenav-route']"
        >
          <ng-icon name="TablerCategory2"></ng-icon>
          @if ((sideNav$ | async).expanded) {
            <span>Category</span>
          }
        </div>

        <div
          class="nav-option"
          [routerLink]="CATEGORY_PUNCHES"
          [routerLinkActive]="['active-sidenav-route']"
        >
          <ng-icon name="HeroHashtag"></ng-icon>
          @if ((sideNav$ | async).expanded) {
            <span>Category Punches</span>
          }
        </div>

        <div
          class="nav-option"
          [routerLink]="SENTIMENT"
          [routerLinkActive]="['active-sidenav-route']"
        >
          <ng-icon name="TablerMoodNervous"></ng-icon>
          @if ((sideNav$ | async).expanded) {
            <span>Sentiment</span>
          }
        </div>
      </div>

      <!--CX API Usage-->
      <div class="nav-group">
        @if ((sideNav$ | async).expanded) {
          <div class="nav-group-header">
            <div class="nav-group-title">CX API Usage</div>
          </div>
        }
        <div
          class="nav-option"
          [routerLink]="API_USAGE_ANALYTICS"
          [routerLinkActive]="['active-sidenav-route']"
        >
          <ng-icon name="TablerLayoutDashboard"></ng-icon>
          @if ((sideNav$ | async).expanded) {
            <span>Overview</span>
          }
        </div>
        <div
          class="nav-option"
          [routerLink]="API_CATEGORY_ANALYTICS"
          [routerLinkActive]="['active-sidenav-route']"
        >
          <ng-icon name="TablerChartPie"></ng-icon>
          @if ((sideNav$ | async).expanded) {
            <span>Category Analytics</span>
          }
        </div>
        <div
          class="nav-option"
          [routerLink]="RECOMPARE"
          [routerLinkActive]="['active-sidenav-route']"
        >
          <ng-icon name="TablerLayersIntersect"></ng-icon>
          @if ((sideNav$ | async).expanded) {
            <span>Recompare</span>
          }
        </div>
        <div
          class="nav-option"
          [routerLink]="REPORTS"
          [routerLinkActive]="['active-sidenav-route']"
        >
          <ng-icon name="TablerServer"></ng-icon>
          @if ((sideNav$ | async).expanded) {
            <span>API Usage Logs</span>
          }
        </div>
      </div>

      <!--Api Report-->
      <div class="nav-group">
        @if ((sideNav$ | async).expanded) {
          <div class="nav-group-header">
            <div class="nav-group-title">Reports</div>
          </div>
        }
        <div
          class="nav-option"
          [routerLink]="DOWNLOADS"
          [routerLinkActive]="['active-sidenav-route']"
        >
          <ng-icon name="HeroDownload"></ng-icon>
          @if ((sideNav$ | async).expanded) {
            <span>Exports</span>
          }
        </div>
      </div>

      <!--General-->
      <div class="nav-group">
        @if ((sideNav$ | async).expanded) {
          <div class="nav-group-header">
            <div class="nav-group-title">Workspace</div>
          </div>
        }
        <div
          class="nav-option"
          [routerLink]="MEMBERS"
          [routerLinkActive]="['active-sidenav-route']"
        >
          <ng-icon name="HeroUserGroup"></ng-icon>
          @if ((sideNav$ | async).expanded) {
            <span>Members</span>
          }
        </div>
        <div
          class="nav-option"
          [routerLink]="SETTINGS"
          [routerLinkActive]="['active-sidenav-route']"
        >
          <ng-icon name="HeroCog"></ng-icon>
          @if ((sideNav$ | async).expanded) {
            <span>Settings</span>
          }
        </div>
      </div>

      <div class="fill"></div>
    </div>
  </mat-sidenav>
  <mat-sidenav-content class="router-outlet">
    <div class="nav-content">
      <router-outlet></router-outlet>
    </div>
  </mat-sidenav-content>
</mat-sidenav-container>
<app-nav-toggler></app-nav-toggler>
